import { gql } from "@apollo/client";

const schema = {
  get: {
    name: 'shopType',
    serviceName: 'graphql',
    query: gql`
      query shopType($ids: [String]) {
        shopType(ids: $ids) {
          data {
            title
            details
          }
        }
      }
    `,
  },
  update: {
    name: 'updateShopType',
    serviceName: 'admin',
    query: gql`
      mutation updateShopType($ids: [String]!, $title: String, $details: String) {
        updateShopType(ids: $ids, title: $title, details: $details) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
